import { useRef } from 'react'
import { SurveyEngine_Models_Block, SurveyEngine_Models_Command } from '../../../api'
import { Label } from "@progress/kendo-react-labels";
import { UserResponse, validationError } from '../../../Common'
import { RenderCommand } from '../Render/RenderCommand'
import parse from 'html-react-parser'
import { BlockSumTo } from '../../atoms/BlockSumTo/BlockSumTo';
import { BlockError } from '../../atoms/BlockError/BlockError';
import { useBlockCtx } from '../../../Context/BlockContext';

interface BlockCommandProps {
  NextQuestion: SurveyEngine_Models_Block,
  APIStatusCode: number,
  ValidationErrors: validationError[],
  getNextQuestionCommand: (surveySID: string, payLoad: UserResponse, isFirstTime?: boolean) => void
}

export default function BlockCommand(props: BlockCommandProps) {

  let userBlockCtx = useBlockCtx()
  let commandIndexOnfocus = useRef(0);
  const labelId = `${props.NextQuestion.commandIndex}_label`
  commandIndexOnfocus.current = 0;
  
  return (

    <>
      {props.NextQuestion.keepOnPage ?
        <div className="theme-block block flex-col">
          <Label
            className="pb-1 text-xl font-semibold"
            data-testid={labelId}
            id={labelId}
          >
            {parse(props.NextQuestion.message?.replace(/""/g, '"') ?? "" as string,)}
          </Label>
          <BlockError />
          {props.NextQuestion.commands?.map((c: SurveyEngine_Models_Command, index: number) => {
            let validationError = props.ValidationErrors.find((e: validationError) => e.commandIndex === c.commandIndex)
            //if(commandIndexOnfocus.current === 0)
            if (props.ValidationErrors.length <= 0 && index === 0 && commandIndexOnfocus.current === 0 && userBlockCtx.resetFocus) {
              commandIndexOnfocus.current = c.commandIndex!;
            }
            if (validationError && commandIndexOnfocus.current === 0 && userBlockCtx.resetFocus) {
              commandIndexOnfocus.current = validationError.commandIndex;
            }
            return <div key={`BlockKey${c.commandIndex!}`} className='theme-block-item pb-6 my-8'>
              <RenderCommand id={c.commandIndex!}
                NextQuestion={c}
                APIStatusCode={props.APIStatusCode}
                ValidationError={validationError}
                focus={commandIndexOnfocus.current === c?.commandIndex}
                getNextQuestionCommand={props.getNextQuestionCommand}
              />
            </div>
          })}
          {
            props.NextQuestion && props.NextQuestion.sumTo && props.NextQuestion.sumTo > 0 ?
              <div>
                <BlockSumTo id={props.NextQuestion.commandIndex!} sumToTotal={props.NextQuestion.sumTo}></BlockSumTo>
              </div>
              :
              <></>
          }

        </div>
        :
        <>
        <RenderCommand id={props.NextQuestion.commands![userBlockCtx.currentIndex].commandIndex!}
                NextQuestion={props.NextQuestion.commands![userBlockCtx.currentIndex]}
                APIStatusCode={props.APIStatusCode}
                ValidationError={props.ValidationErrors[0]}
                focus={true}
                getNextQuestionCommand={props.getNextQuestionCommand}
              />
        </>
      }
    </>


  )
}
